module.exports = __webpack_public_path__ + "static/media/会员.3512e59a.svg";